module.exports = __webpack_public_path__ + "img/course_reward_logo.a7aa4668.png";